import { useEffect } from 'react';
import { utils } from '@/utils';

type ApiConsole = Window['api'];
type ConsoleResult = Promise<Response> | false;

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

function printResult<R extends ConsoleResult>(result: R): R {
  if (result !== false) {
    result
      // Print from a clone so the caller still receives an unread body.
      .then((response) => response.clone().json())
      .then((body: unknown) => {
        if (isRecord(body) && body.result != null) console.table(body.result);
      })
      .catch(() => {});
  }
  return result;
}

const makeConsole = (printResponses: boolean): ApiConsole => {
  const client = utils.apiCallInstance.legacyAmbientApiCall();
  const wrap = <R extends ConsoleResult>(result: R): R => (printResponses ? printResult(result) : result);

  return {
    get token() {
      return client.token;
    },
    makeurl: (path) => client.makeUrl(path),
    get: (path, params, headers, options) => wrap(client.get(path, params, headers, options)),
    patch: (path, params, headers, options) => wrap(client.patch(path, params, headers, options)),
    put: (path, params, headers, options) => wrap(client.put(path, params, headers, options)),
    post: (path, params, formdata, headers, options) => wrap(client.post(path, params, formdata, headers, options)),
    delete: (path, params, headers, options) => wrap(client.delete(path, params, headers, options)),
  };
};
export const ApiConsoleComponent = () => {
  useEffect(() => {
    window.api = makeConsole(false);
    window.a = makeConsole(true);
  }, []);

  return null;
};
